import React from 'react';

import { log } from '../../services/utils';

import AuthRouter from './AuthRouter';

const AuthPortal = () => (
	<>
		{ log( 'authPortal' ) }
		<AuthRouter />
	</>
);

export default AuthPortal;
